
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDriver"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDriver"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneDialCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"picture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"licenceFront"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"licenceBack"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"licenceFrontName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"licenceBackName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicleDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicleName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleRC"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicleInsurance"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"allowedModules"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryAcceptance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accepted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noResponse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"acceptanceRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priorityFactor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"earlyCompletions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"earlyCompletionThresholdMeters"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"windowDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overridePercent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overrideExpiresAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overrideReason"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":693}};
    doc.loc.source = {"body":"query getDriver($id: Int!) {\n\tgetDriver(id: $id) {\n\t\tid\n\t\temail\n\t\tphoneDialCode\n\t\tphoneNumber\n\t\tphoneCountryCode\n\t\tuserStatus\n\t\tisBan\n\t\tisActive\n\t\tactiveStatus\n\t\tlocation {\n\t\t\tid\n\t\t}\n\t\tprofile {\n\t\t\tfirstName\n\t\t\tlastName\n\t\t\tcountry\n\t\t\tpicture\n\t\t\tlicenceFront\n\t\t\tlicenceBack\n\t\t\tlicenceFrontName\n\t\t\tlicenceBackName\n\t\t}\n\t\tvehicleDetails {\n\t\t\tvehicleName\n\t\t\tvehicleNumber\n\t\t\tvehicleType\n\t\t\tvehicleRC\n\t\t\tvehicleInsurance\n\t\t}\n\t\tallowedModules {\n\t\t\tid\n\t\t}\n\t\tdeliveryAcceptance {\n\t\t\toffers\n\t\t\taccepted\n\t\t\tnoResponse\n\t\t\tacceptanceRate\n\t\t\tpriorityFactor\n\t\t\tcompletions\n\t\t\tearlyCompletions\n\t\t\tearlyCompletionThresholdMeters\n\t\t\twindowDays\n\t\t\toverridePercent\n\t\t\toverrideExpiresAt\n\t\t\toverrideReason\n\t\t}\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getDriver"] = oneQuery(doc, "getDriver");
        
